module.exports = __webpack_public_path__ + "img/huoshan-1.b97b696f.png";